/**
 * Nerivio n-level-menu JS
 */

/* eslint-disable */
(function nLevelMenuComp($, Drupal) {
  Drupal.behaviors.myModule = {
    attach: function (context, settings) {
      function menuJS(context) {
        // Define the breakpoint for desktop
        const desktopBreakpoint = 1200;
        const $menuItems = $('.n-level .li-menu.haschild', context);

        // Function to handle desktop behavior
        function setupDesktopBehavior() {
          // Remove any click handlers first to avoid duplication
          $menuItems.off('click');

          // Add hover behavior for desktop
          $menuItems
            .off('mouseenter mouseleave')
            .on('mouseenter', function () {
              $(this).addClass("expand");
            })
            .on('mouseleave', function () {
              $(this).removeClass("expand");
            });
        }

        // Function to handle mobile/tablet behavior
        function setupMobileBehavior() {
          $menuItems.off('mouseenter mouseleave');

          $menuItems.off('click');
          $('.n-level .li-menu.haschild > a', context).off('click');

          // Close other expanded menus when a new one is clicked
          function closeOtherExpandedItems($currentItem) {
            $menuItems.not($currentItem).removeClass('expand');
          }

          // Add click handler for the li element
          $menuItems.on('click', function (e) {
            const $this = $(this);
            const $link = $this.children('a').first();

            // Only trigger if clicking on the li itself, not on the link or child elements
            if (e.target === this) {
              e.preventDefault();
              e.stopPropagation();

              if ($this.hasClass('expand')) {
                $this.removeClass('expand');
              } else {
                closeOtherExpandedItems($this);
                $this.addClass('expand');
              }
            }
          });

          // Add click handler for the anchor within haschild
          $('.n-level .li-menu.haschild > a', context).on('click', function (e) {
            const $parentLi = $(this).parent('.haschild');

            // If parent isn't expanded yet, prevent default and expand it
            if (!$parentLi.hasClass('expand')) {
              e.preventDefault();
              closeOtherExpandedItems($parentLi);
              $parentLi.addClass('expand');
            }
            // If it's already expanded, let the link function normally
          });

          // Close expanded menus when clicking outside
          $(document).on('click', function (e) {
            if (!$(e.target).closest('.n-level .li-menu.haschild').length) {
              $menuItems.removeClass('expand');
            }
          });
        }

        // Initial setup based on window size
        function setInitialBehavior() {
          if (window.matchMedia(`(min-width: ${desktopBreakpoint}px)`).matches) {
            setupDesktopBehavior();
          } else {
            setupMobileBehavior();
          }
        }

        // Set up initial behavior
        setInitialBehavior();

        // Handle window resize
        $(window).off('resize.menuBehavior').on('resize.menuBehavior', function () {
          setInitialBehavior();
        });
      }
      menuJS();

      // Replace the ® character with <sup>®</sup> for superscript.
      $('.n-level-menu .li-menu a', context).html(function (index, html) {
        // First remove any existing sup tags around ® symbols
        let cleaned = html.replace(/<sup>®<\/sup>/g, "®");
        // Then apply the sup tags consistently
        return cleaned.replace(/®/g, "<sup>®</sup>");
      });
    }
  };
})(jQuery, Drupal);
